import React, { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import { useNavigate } from 'react-router-dom';
import { Box, Table, TableCell, TableContainer, TableHead, TableBody, TableRow, TablePagination, Card, CardHeader, CardContent, Divider, IconButton, Chip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import ReportRequestScreen_2 from '../ReportRequestScreen/ReportRequestScreen_2';

function ReportRequestScreen() {
  const [reportData, setReportData] = useState([]);
  const [orderBy, setOrderBy] = useState('');
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedKulKodu, setSelectedKulKodu] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = (sortField = '') => {
    axios
      .get('/GetReports')
      .then(response => {
        let data = Array.isArray(response.data) ? response.data : [];
        if (sortField) {
          data = data.sort((a, b) => {
            if (a[sortField] < b[sortField]) return -1;
            if (a[sortField] > b[sortField]) return 1;
            return 0;
          });
        }
        setReportData(data);
      })
      .catch(error => {
        // Hata yönetimi
      });
  };

  const handleSort = field => {
    setOrderBy(field);
    handleSearch(field);
  };

  const handleOpen = row => {
    setSelectedRow(row.RAPOR_KODU);
    setSelectedKulKodu(row.ACIKLAMA);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Card>
        <CardHeader title="Rapor İstek Ekranı" />
        <Divider />
        <CardContent>
          <TableContainer>
            <Table size="medium">
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: 700, cursor: 'pointer' }}
                    onClick={() => handleSort('RAPOR_KODU')}
                  >
                    No
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: 700, cursor: 'pointer' }}
                    align="center"
                    onClick={() => handleSort('ACIKLAMA')}
                  >
                    Açıklama
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(row => (
                    <TableRow hover key={row.ID}>
                      <TableCell align="center">
                        <Chip
                          label={row.RAPOR_KODU}
                          size="small"
                          variant="outlined"
                          clickable
                          onClick={() => handleOpen(row)}
                        />
                      </TableCell>
                      <TableCell align="center">{row.ACIKLAMA}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={reportData?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </CardContent>
      </Card>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <ReportRequestScreen_2
              reportNo={selectedRow}
              kulRapor={selectedKulKodu}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ReportRequestScreen;
